import { useContext } from 'react';
import { AuthContext } from '@/contexts/AuthContext';

/**
 * AuthContext 편의 훅.
 * <AuthProvider> 내부에서만 사용 가능.
 */
export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
